import { apiSlice } from "app/api/apiSlice"


export const businessUnitApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['BusinessUnits', 'BusinessUnitDetail'],
    endpoints: builder => ({
        // GET Detail
        getBusinessUnitDetail: builder.query({
            query: (guid) => {
                return {
                    url: 'company/businessUnit/detail',
                    params: {
                        businessUnitGUID: guid
                    }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['BusinessUnitDetail']
        }),
        // GET All
        getBusinessUnits: builder.query({
            query: () => 'company/businessUnit',
            keepUnusedDataFor: 5,
            providesTags: ['BusinessUnits']
        }),
        // CREATE
        createBusinessUnit: builder.mutation({
            query: data => ({
                url: 'company/businessUnit',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['BusinessUnits']
        }),
        // UPDATE
        updateBusinessUnit: builder.mutation({
            query: data => ({
                url: 'company/businessUnit',
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['BusinessUnits', 'BusinessUnitDetail']
        }),
        // DELETE
        deleteBusinessUnit: builder.mutation({
            query: guid => ({
                url: 'company/businessUnit',
                method: 'DELETE',
                params: {
                    businessUnitGUID: guid
                }
            }),
            invalidatesTags: ['BusinessUnits']
        }),
    })
})

export const {
    useGetBusinessUnitDetailQuery,
    useGetBusinessUnitsQuery,
    useCreateBusinessUnitMutation,
    useUpdateBusinessUnitMutation,
    useDeleteBusinessUnitMutation
} = businessUnitApiSlice
